import React from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/studio.jpg'
import work from '../../assets/images/work/13.jpg'

import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import FooterTopThree from "../../components/footerTopThree";

import { TypeAnimation } from 'react-type-animation';

import { clientData, clientImage, companyLogoImg, studioProject } from "../../data/data";

import { FiTag, LuUser2, FiArrowRight } from '../../assets/icons/icons'

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

export default function IndexStudio(){

    let settings = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
      };
    return(
        <>
        <Navbar/>
        <section className="bg-half-170 d-table w-100">
            <div className="container">
                <div className="row mt-5">
                    <div className="col-12">
                        <div className="heading-title">
                            <h4 className="display-4 fw-bold mb-3">We are 
                            <TypeAnimation
                                sequence={[
                                    'Creative',
                                    1000, 
                                    'Modern',
                                    1000,
                                    'Studio',
                                    1000,
                                    'Brand',
                                    1000
                                ]}
                                wrapper="span"
                                speed={50}
                                repeat={Infinity}
                                className="ms-2 typewrite text-primary position-relative text-type-element"
                                cursor={false}
                                />
                            <br/>Work Smart. Not Hard.</h4>
                            <p className="para-desc text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div className="container-fluid">
            <div className="py-5 rounded" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
                <div className="container">
                    <div className="row">
                        <div className="offset-lg-8 offset-md-6 col-lg-4 col-md-6">
                            <div className="cta-review bg-primary shadow-lg rounded p-4 py-5">
                                <div className="tiny-single-item">
                                    <TinySlider settings={settings}>
                                        {clientData.map((item, index) =>{
                                            return(
                                                <div className="tiny-slide" key={index}>
                                                    <div className="customer-testi">
                                                        <p className="text-white-50 fst-italic">{item.desc}</p>
                                                        <div className="d-flex align-items-center mt-4">
                                                            <img src={item.image} className="img-fluid avatar avatar-small rounded-circle shadow" alt=""/>
                                                            <div className="flex-1 ms-3">
                                                                <h6 className="text-white title-dark mb-0">{item.name}</h6>
                                                                <small className="text-white-50">{item.title}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </TinySlider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section className="pt-md-0 cta-section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-6">
                        <div className="row mt-4">
                            {companyLogoImg.map((item, index) =>{
                                return(
                                    <div className="col-lg-3 col-md-4 col-6 text-center py-4" key={index}>
                                        <img src={item} className="avatar avatar-client" alt=""/>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 mb-4 pb-2">
                        <div className="section-title">
                            <h5 className="text-primary">Projects</h5>
                            <h2 className="mb-4">Front makes designing easy and performance fast</h2>
                            <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div id="grid" className="row">
                    <div className="col-md-4 mt-4 pt-2 picture-item">
                        <div className="card work-container work-primary border-0">
                            <img src={work} className="img-fluid rounded shadow-md" alt=""/>

                            <div className="card-body content mt-4 p-0">
                                <ul className="list-unstyled d-flex justify-content-between mb-2">
                                    <li><FiTag className="me-1"/><Link to="#" className="text-muted tag">Creative</Link></li>
                                    <li><LuUser2 className="me-1"/><Link to="#" className="text-muted author">Calvin</Link></li>
                                </ul>
                                <Link to="#" className="title text-dark h5">Creative and modern design</Link>
                                <p className="text-muted mt-2 d-none d-md-block">Composed in a pseudo-Latin language which more or less pseudo-Latin language corresponds.</p>
                                <div className="mt-2">
                                    <Link to="#" className="text-dark link">Read More <FiArrowRight className="fea icon-sm"/></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="row">
                            {studioProject.map((item, index) =>{
                                return(
                                    <div className="col-md-6 mt-4 pt-2 picture-item" key={index}>
                                        <div className="card work-container work-primary border-0">
                                            <img src={item.image} className="img-fluid rounded shadow-md" alt=""/>
                
                                            <div className="card-body content mt-4 p-0">
                                                <ul className="list-unstyled d-flex justify-content-between mb-2">
                                                    <li><FiTag className="me-1"/><Link to="#" className="text-muted tag">{item.tag}</Link></li>
                                                    <li><LuUser2 className="me-1"/><Link to="#" className="text-muted author">{item.name}</Link></li>
                                                </ul>
                                                <Link to="#" className="title text-dark h5">{item.title}</Link>
                
                                                <div className="mt-2">
                                                    <Link to="#" className="text-dark link">Read More <FiArrowRight className="fea icon-sm"/></Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Our Team</h6>
                            <h4 className="title mb-4">Creative Team Members</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-9 mt-4">
                        <ul className="list-unstyled text-center mb-0"> 
                            {clientImage.map((item, index) =>{
                                return(
                                    <li className="list-inline-item m-2" key={index}>
                                        <Link to="#"><img src={item} className="rounded-circle avatar avatar-medium shadow-md" alt=""/></Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <FooterTopThree/>
        <Footer/>
        <ScrollTop/>
        </>
    )
}